import { render, staticRenderFns } from "./AccountEmail.vue?vue&type=template&id=0add43d6&"
import script from "./AccountEmail.vue?vue&type=script&lang=js&"
export * from "./AccountEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports